import { FindQuery } from "graphql.generated";

export const timelineBookEventInitialState = {
  bookEventDialog: {
    eventId: undefined as string | undefined,

    date: undefined as string | undefined,
    time: undefined as string | undefined,
    assetIds: [] as string[],

    windows: [] as FindQuery['find']['windows'],

    showAssetsNotAvailableWarning: false as boolean,
    showTimeNotAvailableWarning: false as boolean,
    restrictionsDisabled: false as boolean,
    pinStartTime: false as boolean,

    scheduleMode: 'view' as 'view' | 'schedule',

    rescheduleEventMode: false as boolean,
  }
} as const;

export type TimelineBookEventState = typeof timelineBookEventInitialState;
